// removed by extract-text-webpack-plugin
module.exports = {"quoteSection":"styles__quoteSection__2AUuc","quote":"styles__quote__2M5Q9","domainExpertise":"styles__domainExpertise__3vRjI","software":"styles__software__1Wt2R","whatTheyreLike":"styles__whatTheyreLike__1XX5I","col-xs-6":"styles__col-xs-6__2op4A","bestWay":"styles__bestWay__SvFg_","footer":"styles__footer__1gmSr","whatTheyLike":"styles__whatTheyLike__1OwP1","workPanel":"styles__workPanel__Ij6sQ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Talent/styles.scss
// module id = 428
// module chunks = 0